// src/components/OffersGrid.jsx
import React, { useState } from "react";
import NoImage from '../img/No__image.jpg'

const OffersGrid = ({ offers }) => {
    const pageSize = 6;
    const [currentPage, setCurrentPage] = useState(1);
    const pageCount = Math.ceil(offers.length / pageSize);


    // Offerte da mostrare nella pagina corrente
    const currentOffers = offers.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const goTo = (page) => {
        if (page < 1 || page > pageCount) return;
        setCurrentPage(page);
    };

    return (
        <div>
            {/* Griglia prodotti */}
            <div className="row">
                {currentOffers.map((o) => (
                    <div key={o.codice} className="col-12 col-md-4 mb-4">
                        <div className="card border-radius-8 h-100">
                            <div className="p-2">
                                <img
                                    src={o.url_immagine}
                                    className="card-img-top"
                                    alt={o.articolo_nome}
                                    style={{ objectFit: "contain", height: "200px" }}
                                    onError={e => {
                                        e.currentTarget.onerror = null; 
                                        e.currentTarget.src = NoImage;
                                    }}
                                />
                            </div>
                            <div className="card-body d-flex flex-column text-center">
                                <h5 style={{ minHeight: '48px' }} className="card-title">{o.articolo_nome}</h5>
                                <span style={{ color: 'var(--text-offert)' }} className="text-16 bold">PREZZO OFFERTA</span>
                                <p style={{ color: 'var(--text-offert)' }} className="card-text mt-auto fw-bold">€ {o.prezzo}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Paginazione */}
            {pageCount > 1 && (
                <nav>
                    <ul className="pagination justify-content-center">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                                className="page-link d-flex "
                                onClick={() => goTo(currentPage - 1)}
                            >
                                <div style={{ width: '20px', height: '20px' }} className="icon icon-vector-left"></div>
                            </button>
                        </li>

                        {Array.from({ length: pageCount }, (_, i) => i + 1).map((p) => (
                            <li
                                key={p}
                                className={`page-item ${p === currentPage ? "active" : ""
                                    }`}
                            >
                                <button className="page-link" onClick={() => goTo(p)}>
                                    {p}
                                </button>
                            </li>
                        ))}

                        <li
                            className={`page-item ${currentPage === pageCount ? "disabled" : ""
                                }`}
                        >
                            <button
                                className="page-link"
                                onClick={() => goTo(currentPage + 1)}
                            >
                                <div style={{ width: '20px', height: '20px' }} className="icon icon-vector-right"></div>
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
};

export default OffersGrid;
